import SvgIcon from '@material-ui/core/SvgIcon';

export default function Coordinate(props:any) {
  return (
    <SvgIcon viewBox='0 0 20 20' { ...props}>
  <path d="M7.72041 4.94458V1.22266H4.04102V4.94458H7.72041ZM4.92437 2.1157H6.83918V4.05142L4.92437 4.05157V2.1157Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5"/>
  <path d="M18.7794 1.22266H15.0977V4.94458H18.7794V1.22266ZM17.896 4.05154H15.9811V2.11566H17.8959L17.896 4.05154Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5"/>
  <path d="M19 18.1072H2.50855L13.8674 6.62435L13.2422 5.99249L1.88336 17.4754V1H1V19H19V18.1072Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5"/>
  <path d="M15.0977 16.1025H18.7794V12.3828H15.0977V16.1025ZM15.981 13.2737H17.8958V15.2094L15.981 15.2095V13.2737Z" fill="currentColor" stroke="currentColor" strokeWidth="0.5"/>
    </SvgIcon>
  );
}
